import { connect } from 'react-redux';
import * as R from 'ramda';
import InventoryOwnerAutoComplete from './InventoryOwnerAutoComplete';
import { fetchInventoryOwners, getStoreValueByProp } from '../store/sequencingWizardSlice';

const mapState = R.applySpec({
  inventoryOwners: getStoreValueByProp(['inventoryOwners']),
});

const mapDispatch = {
  fetchInventoryOwners,
};

export default connect(mapState, mapDispatch)(InventoryOwnerAutoComplete);
